import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CanDeactivate } from '@angular/router';
import { ReportsService } from '../../../Common/Reports/services/reports.service';
import { ReportComponent } from '../../../Common/Reports/components/Report/report.component';

@Injectable()
export class ReportsDeactivateGuard implements CanDeactivate<ReportComponent> {
    constructor(
        public reportsService: ReportsService
    ) {}

    canDeactivate(
        component: ReportComponent
    ): Observable<boolean> {
        return this.reportsService.showCanLeaveDialog();
    }
}
